<ng-container *transloco="let t; prefix: 'wiki'">
    <!-- Button -->
    <button (click)="openWiki()" [matTooltip]="t('open-wiki')" mat-icon-button>
        <mat-icon [svgIcon]="'heroicons_outline:book-open'"></mat-icon>
    </button>
</ng-container>
